import { useState } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { useBrand } from "@/contexts/BrandContext";
import { usePopularItems } from "@/hooks/usePopularItems";
import MenuItemCard from "@/components/shared/MenuItemCard";
import ItemDetailModal from "@/components/shared/ItemDetailModal";
import { MenuItem } from "@/hooks/usePublicMenu";

export default function PicksSection() {
  const { language } = useLanguage();
  const { brand } = useBrand();
  const { items: popularItems, loading } = usePopularItems(brand.id);
  const [selectedItem, setSelectedItem] = useState<MenuItem | null>(null);

  return (
    <section className="py-20 md:py-28 bg-card">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="font-heading text-4xl md:text-6xl font-black text-foreground">
            {language === "ar" ? "اختياراتنا" : "Our Picks"}
          </h2>
          <div className="w-16 h-1 bg-primary mx-auto mt-4 rounded-full" />
        </div>

        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="rounded-2xl border bg-background animate-pulse aspect-square" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
            {popularItems.slice(0, 8).map((item) => (
              <MenuItemCard key={item.id} item={item} onClick={setSelectedItem} />
            ))}
          </div>
        )}
      </div>

      {selectedItem && (
        <ItemDetailModal item={selectedItem} onClose={() => setSelectedItem(null)} />
      )}
    </section>
  );
}
